import { Paragraph } from '@fs/zion-ui'
import React from 'react'
import { Trans } from 'react-i18next'
import { type GedcomData } from '../../../services/useGedcomDataHook'
import { usePrivatePersonCountContext } from '../../../providers/PrivatePersonCountProvider'

const NoSpacerParagraph = (props: Omit<React.ComponentProps<typeof Paragraph>, 'size'>): JSX.Element => (
  <div>
    <Paragraph size="sm" {...props} />
  </div>
)

type Props = {
  gedcomData?: GedcomData
}

export default function AboutThisTreeContent({ gedcomData }: Props): JSX.Element {
  const { privatePersonCount } = usePrivatePersonCountContext()

  return (
    <>
      {!!privatePersonCount && (
        <NoSpacerParagraph>
          <Trans i18nKey="group-management.tree-person-count.label" values={{ count: privatePersonCount }} />
        </NoSpacerParagraph>
      )}

      {gedcomData && (
        <>
          <NoSpacerParagraph>
            <Trans i18nKey="group-management.upload-date.label" values={{ date: gedcomData.uploadDate }} />
          </NoSpacerParagraph>
          <NoSpacerParagraph>
            <Trans i18nKey="group-management.file-name.label" values={{ fileName: gedcomData.fileName }} />
          </NoSpacerParagraph>
        </>
      )}
    </>
  )
}
